import React from "react";
import "./Logo.css";

const Logo = ({ size = "md" }) => {
  return (
    <div className={`Logo Logo--${size}`}>
      <span className="Logo--Mark" aria-hidden="true">
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16 3l3.6 7.4 8.2 1.2-5.9 5.7 1.4 8.1L16 21.7 8.7 25.4l1.4-8.1L4.2 11.6l8.2-1.2L16 3z"
            fill="currentColor"
            opacity="0.18"
          />
          <path
            d="M16 5.5l2.7 5.5 6.1.9-4.4 4.3 1 6-5.4-2.8-5.4 2.8 1-6-4.4-4.3 6.1-.9L16 5.5z"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span className="Logo--Wordmark">
        <span className="Logo--Title">Шахризада</span>
        <span className="Logo--Subtitle">Восточное кафе</span>
      </span>
    </div>
  );
};

export default Logo;
